import React, { Component } from "react";

import { CCard, CCardHeader, CCardBody, CLabel } from "@coreui/react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import CreateFilterOffline from "../../../components/OfflineRegister/CreateFilterOffline";
import StudentPresenceTable from "../../../components/OfflineRegister/StudentPresenceTable";
import ProtectedRoute from "../../../components/ProtectedRoute";
import RichText from "../../../components/RichText/SlateEditor/Editor";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class DailyRecordView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contents: [],
      disciplineSelected: null,
      date: null,

      student_list: null,
      infoSelected: null,
      arrayAbilities: [],
      data: null,
      description: null
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    axios
      .get(`${URL.api}daily/singleView/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let text = JSON.parse(resp.data.data.text);
        this.setState({
          arrayAbilities: resp.data.data.abilities,
          description: resp.data.data.text
        });
        let newUsers = [];
        resp.data.data.users.forEach(item => {
          let obj = {
            id: item.id,
            nome: item.student_name,
            status: item.accessed === true ? "Presente" : "Ausente"
          };
          newUsers.push(obj);
        });
        let newData = resp.data.data;
        newData.users = newUsers;
        this.setState({ data: newData });
      });
  }

  changeDisciplineSelected = disciplineSelected => {
    this.setState({ disciplineSelected });
  };

  getStudentList = studentList => {
    this.setState({ student_list: studentList });
  };

  removeContent = contentName => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const contentList = [...this.state.contents];
    const position = contentList.indexOf(contentName);
    contentList.splice(position, 1);
    this.setState({ contents: contentList });
  };

  addContent = (contentName, contentId) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const contentList = [...this.state.contents];
    let obj = {
      contentName,
      contentId
    };
    contentList.push(obj);
    this.setState({ contents: contentList });
  };

  hideModal = hide => {
    // this.setState({ showModal: !hide });
  };

  getDate = date => {
    let myDate = `${date}`;
    myDate = myDate.replaceAll("-", ".");
    let newDate = new Date(Math.floor(new Date(myDate).getTime()));
    this.setState({ date: newDate });
  };

  getInfoSelectors = (groupId, regionId, schoolId, roomId, teacherId) => {
    let obj = {
      groupId,
      regionId,
      schoolId,
      roomId,
      teacherId
    };
    this.setState({ infoSelected: obj });
  };

  addNewRegister = addAnotherRoom => {
    let studentList = [];
    this.state.student_list.forEach(item => {
      let obj = {
        student_id: item.id,
        accessed: item.status === "Presente"
      };
      studentList.push(obj);
    });

    let contentList = [];
    this.state.contents.forEach(item => {
      contentList.push(item.contentId);
    });

    let obj = {
      user_id: this.props.user.user.id,
      room_id: this.state.infoSelected.roomId,
      discipline_id: this.state.disciplineSelected.value,
      date: this.state.date,
      users: studentList,
      content: contentList,
      teacher_id:
        this.state.infoSelected.teacherId !== 0
          ? this.state.infoSelected.teacherId
          : null
    };
    axios
      .post(`${URL.api}daily/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(() => {
        if (!addAnotherRoom) {
          let url = "/daily/list";
          this.props.history.push(url);
        } else {
          this.disableFields;
        }
        resp => {},
          () => {
            this.error("Não foi possível adicionar o Registro Offline");
          };
      });
  };

  disableFields = () => {};

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const serie = query.get("serie") || null;
    const discipline = query.get("discipline") || null;

    return (
      <div className="d-flex flex-column align-items-left">
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/daily/list", to: "/daily/list" }]}
        />
        {this.state.data && (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">Visualizar Registro Diário</h4>
                <div className="small text-muted">
                  Visualize os dados do Registro Diário
                </div>
              </div>
            </CCardHeader>
            <CCardBody>
              <CreateFilterOffline
                user={this.props.user}
                getDate={this.getDate}
                getInfoSelectors={this.getInfoSelectors}
                viewOfflineRegister
                infoView={this.state.data}
              />
              <div className="myRow">
                <div className="flex-1 mb-2">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">
                      Disciplina
                    </Label>
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Select
                      placeholder="Selecione a Disciplina"
                      onChange={e => this.changeDisciplineSelected(e)}
                      defaultValue={{
                        label: this.state.data.discipline_name,
                        value: 0
                      }}
                      type="text"
                      isDisabled
                      className="flex-1"
                    />
                  </InputGroup>
                </div>
                <Label className="d-block w-100 text-ellipsis">
                  Habilidade(s)
                </Label>
                {this.state.arrayAbilities &&
                  this.state.arrayAbilities.map((item, index) => (
                    <FormGroup className="mb3 mt-3" key={index}>
                      <div className="d-flex w-100 mt-2">
                        <div className="mx-2 flex-1">
                          <Select
                            placeholder={item.ability_description}
                            name="Habilidade"
                            options={item.ability_description}
                            value={item.ability_description}
                            className="basic-multi-select flex-1"
                            classNamePrefix="select"
                            noOptionsMessage={() =>
                              "Selecione um Segmento e um Componente curricular"
                            }
                            disabled={false}
                            readOnly={false}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  ))}
                <FormGroup className="mb3 mt-3">
                  <CLabel>Descrição</CLabel>
                  <InputGroup>
                    {this.state.description !== null ? (
                      <RichText
                        setValorDescricao={val =>
                          // eslint-disable-next-line react/no-unused-state
                          this.setState({ ValorDescricao: val })
                        }
                        description={this.state.description}
                        // eslint-disable-next-line react/jsx-boolean-value
                        editavel={false}
                      />
                    ) : (
                      "Campo de Descrição Vazio"
                    )}
                  </InputGroup>
                </FormGroup>
                <CLabel className="mt-2">Lista de Presença</CLabel>
                <StudentPresenceTable
                  getStudentList={this.getStudentList}
                  roomId={
                    this.state.infoSelected ? this.state.infoSelected : null
                  }
                  viewOfflineRegister
                  infoView={this.state.data}
                />
              </div>
            </CCardBody>
            <ProtectedRoute routeId={this.props.currentRoute} />
          </CCard>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DailyRecordView);
